module.exports = __webpack_public_path__ + "img/picto4.499e5098.svg";